// import React from "react";
// import Slider from "react-slick";

// const testimonials = [
//   {
//     name: "Mr. Rahul Sharma",
//     image: "/img/profiles/avatar-02.jpg",
//     rating: 5,
//     text: "Omshree Cab provided an excellent travel experience. The driver was professional, the car was clean, and the journey was very comfortable."
//   },
//   {
//     name: "Ms. Priya Verma",
//     image: "/img/profiles/avatar-03.jpg",
//     rating: 5,
//     text: "I booked an airport ride with Omshree Cab and the service was perfectly on time. Very reliable and affordable cab service."
//   },
//   {
//     name: "Mr. Amit Patel",
//     // image: "/img/profiles/avatar-04.jpg",
//     rating: 5,
//     text: "Great service for outstation travel. The driver was polite and the ride was smooth. I highly recommend Omshree Cab."
//   },
//   {
//     name: "Ms. Neha Gupta",
//     image: "/img/profiles/avatar-06.jpg",
//     rating: 5,
//     text: "Very easy booking and excellent customer support. The cab arrived on time and the journey was safe and comfortable."
//   },
//   {
//     name: "Mr. Sandeep Singh",
//     image: "/img/profiles/avatar-07.jpg",
//     rating: 5,
//     text: "One of the best cab services I have used. Clean vehicles, experienced drivers, and very reasonable pricing."
//   },
// ];

// const AboutTestimonials = () => {
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 2, // Desktop view
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 4000,
//     arrows: false,
//     responsive: [
//       {
//         breakpoint: 1024, // Tablet view
//         settings: {
//           slidesToShow: 1,
//         },
//       },
//       {
//         breakpoint: 600, // Mobile view
//         settings: {
//           slidesToShow: 1,
//         },
//       },
//     ],
//   };

//   return (
//     <section className="section about-testimonial testimonials-section">
//       <div className="container">
//         {/* Heading */}
//         <div className="section-heading" data-aos="fade-down">
//           <h2 className="title text-white">What People say about us?</h2>
//           <p className="description text-white">
//             Discover what our customers have think about us
//           </p>
//         </div>

//         {/* Slider */}
//         <Slider {...settings} className="about-testimonials testimonial-group mb-0">
//           {testimonials.map((testimonial, index) => (
//             <div className="testimonial-item d-flex" key={index}>
//               <div className="card flex-fill">
//                 <div className="card-body">
//                   <div className="quotes-head"></div>
//                   <div className="review-box">
//                     <div className="review-profile">
//                       <div className="review-img">
//                         {/* <img
//                           src={testimonial.image}
//                           className="img-fluid"
//                           alt={testimonial.name}
//                         /> */}
//                       </div>
//                     </div>
//                     <div className="review-details">
//                       <h6>{testimonial.name}</h6>
//                       <div className="list-rating">
//                         <div className="list-rating-star">
//                           {[...Array(testimonial.rating)].map((_, i) => (
//                             <i className="fas fa-star filled" key={i}></i>
//                           ))}
//                         </div>
//                         <p>
//                           <span>({testimonial.rating}.0)</span>
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                   <p>{testimonial.text}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default AboutTestimonials;













import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const testimonials = [
  {
    name: "Mr. Rahul Sharma",
    image: "/img/profiles/avatar-02.jpg",
    rating: 5,
    text: "Omshree Cab provided an excellent travel experience. The driver was professional, the car was clean, and the journey was very comfortable."
  },
  {
    name: "Ms. Priya Verma",
    image: "/img/profiles/avatar-03.jpg",
    rating: 5,
    text: "I booked an airport ride with Omshree Cab and the service was perfectly on time. Very reliable and affordable cab service."
  },
  {
    name: "Mr. Amit Patel",
    image: "/img/profiles/avatar-04.jpg",
    rating: 5,
    text: "Great service for outstation travel. The driver was polite and the ride was smooth. I highly recommend Omshree Cab."
  },
  {
    name: "Ms. Neha Gupta",
    image: "/img/profiles/avatar-06.jpg",
    rating: 5,
    text: "Very easy booking and excellent customer support. The cab arrived on time and the journey was safe and comfortable."
  },
  {
    name: "Mr. Sandeep Singh",
    image: "/img/profiles/avatar-07.jpg",
    rating: 5,
    text: "One of the best cab services I have used. Clean vehicles, experienced drivers, and very reasonable pricing."
  },
];

const AboutTestimonials = () => {
  return (
    <section className="section about-testimonial testimonials-section">
      <div className="container">

        <div className="section-heading" data-aos="fade-down">
          <h2 className="title text-white">What People say about us?</h2>
          <p className="description text-white">
            Discover what our customers have think about us
          </p>
        </div>

        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          loop={true}
          autoplay={{ delay: 4000 }}
          pagination={{ clickable: true }}
          breakpoints={{
            768: {
              slidesPerView: 1
            },
            1024: {
              slidesPerView: 2
            }
          }}
        >

          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>

              <div className="testimonial-item d-flex">
                <div className="card flex-fill">
                  <div className="card-body">

                    <div className="review-box">

                    

                      <div className="review-details">
                        <h6>{testimonial.name}</h6>

                        <div className="list-rating">
                          <div className="list-rating-star">
                            {[...Array(testimonial.rating)].map((_, i) => (
                              <i className="fas fa-star filled" key={i}></i>
                            ))}
                          </div>
                          <span>({testimonial.rating}.0)</span>
                        </div>

                      </div>

                    </div>

                    <p>{testimonial.text}</p>

                  </div>
                </div>
              </div>

            </SwiperSlide>
          ))}

        </Swiper>

      </div>
    </section>
  );
};

export default AboutTestimonials;